import { render, staticRenderFns } from "./BondenWarehouseEdit.vue?vue&type=template&id=044c12e3"
import script from "./BondenWarehouseEdit.vue?vue&type=script&lang=js"
export * from "./BondenWarehouseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports